import { Activator, KeyboardSensor, KeyboardSensorOptions } from '@dnd-kit/core';
import { rectSortingStrategy, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { restrictToParentElement, restrictToVerticalAxis } from '@dnd-kit/modifiers';

export class ShiftSpaceKeyboardSensor extends KeyboardSensor {
  static activators: Activator<KeyboardSensorOptions>[] = [
    {
      eventName: 'onKeyDown' as const,
      handler: ({ nativeEvent: event }) => {
        const isTriggerCombo = event.code === 'Space' && event.shiftKey;

        if (isTriggerCombo) {
          event.preventDefault();
          return true;
        }

        return false;
      },
    },
  ];
}

export const DEFAULT_GRID_PROPS = {
  strategy: rectSortingStrategy,
  modifiers: [restrictToParentElement],
};

export const DEFAULT_VERTICAL_PROPS = {
  strategy: verticalListSortingStrategy,
  modifiers: [restrictToVerticalAxis],
};
